import { render, staticRenderFns } from "./saleTabs.vue?vue&type=template&id=2fb24278&scoped=true&"
import script from "./saleTabs.vue?vue&type=script&lang=js&"
export * from "./saleTabs.vue?vue&type=script&lang=js&"
import style0 from "./saleTabs.vue?vue&type=style&index=0&id=2fb24278&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb24278",
  null
  
)

export default component.exports